import Category from '../../pages/dashboard/Categories';
import ImportList from '../../pages/dashboard/ImportList';
import Messaging from '../../pages/dashboard/messaging/Messaging';
import Orders from '../../pages/dashboard/Orders';
import CartOld from '../../pages/dashboard/CartOld';
import PartnerStore from '../../pages/dashboard/PartnerStore';
import Trending from '../../pages/dashboard/Trending';
import Wallet from '../../pages/dashboard/Wallet';
import Settings from '../../pages/dashboard/Settings';
import OrderDetail from '../../pages/OrderDetail';
import Checkout from '../../pages/dashboard/Checkout';
import Checkout2 from '../../pages/dashboard/Checkout';
import SingleCategory from '../../pages/dashboard/SingleCategory';
import PreOffers from '../../pages/PreOffers';
import Action from '../../pages/Action';
import UploadComPlete from '../../pages/UploadComPlete';
import DesktopTraining from '../../pages/DesktopTraining';
import Delivery from '../../pages/Delivery';
import TransHistory from '../../pages/TransHistory';
import Invoices from '../../pages/Invoices';
import OrderComplete from '../../pages/OrderComplete';
import FundWallet from '../../pages/dashboard/FundWallet';
import CreateProduct from '../../pages/dashboard/PartnerStore/products/CreateProduct';
import PreviewProduct from '../../pages/dashboard/PartnerStore/products/PreviewProduct';
import BrandsPage from 'pages/dashboard/Brands';
import Varsity from '../../pages/dashboard/varsity';
import CRM from '../../pages/dashboard/crm';
import VarsityModules from '../../pages/dashboard/varsity/Modules';
import SingleProductDetail from 'pages/dashboard/SingleProductDetail';
import SingleBrand from 'pages/dashboard/SingleBrand';
import CreateStore from 'pages/dashboard/PartnerStore/createStore';
import CreateStoreForm from 'pages/dashboard/PartnerStore/createStore/form';
import StoreProducts from 'pages/dashboard/PartnerStore/products';
import Products from 'pages/dashboard/Products';
import Cart from 'pages/dashboard/Cart';
import SingleVendor from 'pages/dashboard/SingleVendor';
import AllVendors from 'pages/dashboard/AllVendors';
import { CreateTaskForm } from '../../pages/dashboard/crm/CreateTaskForm';
import { CreateMeetingForm } from 'pages/dashboard/crm/CreateMeetingForm';
import ComingSoonPage from 'pages/ComingSoon';
import Shipments from 'pages/dashboard/Shipments';

const dashboardRoutes = [
    { path: 'shipments', element: <Shipments /> },
    { path: 'messages', element: <Messaging /> },
    { path: 'wallet', element: <Wallet /> },
    { path: 'wallet/fund', element: <FundWallet /> },
    { path: 'import', element: <ImportList /> },
    { path: 'import/:isEmpty', element: <ImportList /> },
    { path: 'store', element: <PartnerStore /> },
    { path: 'cart', element: <Cart /> },
    { path: 'cart-new', element: <CartOld /> },
    { path: 'cart/:isEmpty', element: <Cart /> },
    { path: 'orders/:isEmpty', element: <Orders /> },
    { path: 'order-details/:id', element: <OrderDetail /> },
    { path: 'checkout/:id', element: <Checkout /> },
    { path: 'checkout', element: <Checkout2 /> },
    { path: 'orders', element: <Orders /> },
    { path: 'trending', element: <Trending /> },
    { path: 'categories', element: <Category /> },
    { path: 'products', element: <Products /> },
    { path: 'single-category/:id', element: <SingleCategory /> },
    { path: 'product/details/:id', element: <SingleProductDetail /> },
    { path: 'settings', element: <Settings /> },
    { path: 'pre-offers', element: <PreOffers /> },
    { path: 'actions', element: <Action /> },
    { path: 'coming-soon', element: <ComingSoonPage /> },
    { path: 'delivery', element: <Delivery /> },
    { path: 'complete-training', element: <UploadComPlete /> },
    { path: 'invoice/:id', element: <TransHistory /> },
    { path: 'training', element: <DesktopTraining /> },
    { path: 'invoices/:id', element: <Invoices /> },
    { path: 'brands', element: <BrandsPage /> },
    { path: 'brands/:id', element: <SingleBrand /> },
    { path: 'vendors/:id', element: <SingleVendor /> },
    { path: 'vendors', element: <AllVendors /> },
    { path: 'order-complete/:id', element: <OrderComplete /> },
    { path: 'products', element: <Products /> },
    { path: 'varsity', element: <Varsity /> },
    { path: 'crm', element: <CRM /> },
    { path: 'crm/create-task', element: <CreateTaskForm /> },
    { path: 'crm/create-meeting', element: <CreateMeetingForm /> },
    { path: 'varsity/:id/modules', element: <VarsityModules /> },
    { path: 'store/create-a-store', element: <CreateStore /> },
    { path: 'store/create-a-store/form', element: <CreateStoreForm /> },
    { path: 'store/products', element: <StoreProducts /> },
    { path: 'store/products/create-product', element: <CreateProduct /> },
    { path: 'store/products/preview-product', element: <PreviewProduct /> },
];
export { dashboardRoutes };
